import React from 'react';
import { MdClose, MdSupport } from 'react-icons/md';
import SuperAdminSupportChart from './SuperAdminSupportChart';

const SupportChartModal = ({ 
  isOpen, 
  onClose, 
  userRole, 
  userInfo, 
  API_BASE_URL, 
  auth 
}) => {
  if (!isOpen) return null;

  // Check if user has access to support charts
  const hasAccess = userRole === 'Super Admin' || userRole === 'MMDA Admin';

  if (!hasAccess) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1001,
        padding: 20
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: 12,
          padding: '40px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
        }}>
          <MdSupport style={{ fontSize: '48px', color: '#dc3545', marginBottom: '16px' }} />
          <h3 style={{ margin: '0 0 16px 0', color: '#2c3e50' }}>Access Denied</h3>
          <p style={{ margin: '0 0 24px 0', color: '#666' }}>
            You don't have permission to view support analytics.
          </p>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: '500'
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001,
      padding: 20
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        maxWidth: '95vw',
        width: '100%',
        maxHeight: '95vh',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <MdSupport style={{ color: '#28a745', fontSize: '24px' }} />
            <h3 style={{
              margin: 0,
              fontSize: 20,
              fontWeight: '600',
              color: '#333'
            }}>
              SuperAdmin Support Analytics
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#666',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#e9ecef';
              e.currentTarget.style.color = '#333';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#666';
            }}
          >
            <MdClose size={24} />
          </button>
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          overflow: 'auto'
        }}>
          <SuperAdminSupportChart 
            API_BASE_URL={API_BASE_URL}
            auth={auth}
            userRole={userRole}
          />
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px',
          borderTop: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#666' }}>
            Support analytics for system administrators
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: '500',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#5a6268'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#6c757d'}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportChartModal;
